module.exports = __webpack_public_path__ + "static/media/logo.3bf9c69f.svg";